import PropTypes from 'prop-types';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import RaiseALeadButton from './RaiseALeadButton';
import Tracker from './utils/trackers/QualifiedLeadSidebarCardTracker';
import QualifiedLeadFlags from './QualifiedLeadFlags';
import QualifiedLeadsList from './QualifiedLeadsList';
import QualifiedLeadUnsubmittableStatus from './QualifiedLeadUnsubmittableStatus';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function QualifiedLeadsSidebarCardContent({
  alertStore,
  appName,
  chatThreadId = 0,
  contactVid = 0
}) {
  Tracker.applicationName = appName;
  Tracker.leadContactVid = typeof contactVid === 'string' ? parseInt(contactVid, 10) : contactVid;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(QualifiedLeadUnsubmittableStatus, {
      contactVid: contactVid
    }), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      direction: "row",
      justify: "center",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(RaiseALeadButton, {
        alertStore: alertStore,
        appName: appName,
        chatThreadId: chatThreadId,
        contactVid: contactVid
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(QualifiedLeadsList, {
        contactVid: contactVid
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      as: "div",
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: ["Powered by ", /*#__PURE__*/_jsx("b", {
          children: "Revenue"
        })]
      })
    })]
  });
}
function QualifiedLeadsSidebarCardTitle({
  contactVid = 0
}) {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: ["Qualified Leads", /*#__PURE__*/_jsx(QualifiedLeadFlags, {
      contactVid: contactVid
    })]
  });
}
QualifiedLeadsSidebarCardContent.propTypes = {
  alertStore: PropTypes.object.isRequired,
  appName: PropTypes.string.isRequired,
  chatThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
QualifiedLeadsSidebarCardTitle.propTypes = {
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export { QualifiedLeadsSidebarCardContent, QualifiedLeadsSidebarCardTitle };